import { GetStaticProps } from "next";
import getTranslations from "../lib/getTranslations";
import { Impressum } from "@/components/impressum/Impressum";

const ImpressumPage = () => {
  return <Impressum />;
};

ImpressumPage.getLayout = (page: JSX.Element) => page;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await getTranslations(locale, ["impressum"])),
    },
  };
};

export default ImpressumPage;
